import './NavBar.css';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Resume from "./Resources/cv.pdf"

import { Link } from 'react-router-dom';

function NavBar() {
    //in future make dropdowns based on class

  let projects = require("./Resources/projects");
  let experiences = require("./Resources/experiences")

  return (
     <Navbar expand="lg" className="bg-body-tertiary" data-bs-theme="dark" style={{opacity: "80%"}}>
       <Container>
         <Navbar.Brand as={Link} to="/">Steven Schonlau</Navbar.Brand> {/* Use Link for brand */}
         <Navbar.Toggle aria-controls="basic-navbar-nav" />
         <Navbar.Collapse id="basic-navbar-nav">
           <Nav className="me-auto">
             <Nav.Link as={Link} to="/">Home</Nav.Link> {/* Use Link for navigation */}
             <Nav.Link as={Link} to="/AboutMe">About Me</Nav.Link>
             <NavDropdown title="Projects" id="basic-nav-dropdown">
               <NavDropdown.Item as={Link} to="/Projects">All Projects</NavDropdown.Item>
               <NavDropdown.Divider />
               {projects.projects.map((item) => (
                 <NavDropdown.Item as={Link} to={`/${item.link}`} key={item.link}>{item.name}</NavDropdown.Item> // Link for project routes
               ))}
             </NavDropdown>
             <NavDropdown title="Experiences" id="basic-nav-dropdown">
               <NavDropdown.Item as={Link} to="/Experiences">All Experiences</NavDropdown.Item>
               <NavDropdown.Divider />
               {experiences.experiences.map((item) => (
                 <NavDropdown.Item as={Link} to={`/${item.link}`} key={item.link}>{item.name}</NavDropdown.Item> // Link for experience routes
               ))}
             </NavDropdown>
             <Nav.Link as={Link} to="/Skills">Skills</Nav.Link>
             <Nav.Link href={Resume} target="_blank">Resume</Nav.Link>
             <Nav.Link href="https://github.com/StevenSchonlau" rel="noreferrer" target="_blank">GitHub</Nav.Link>
             <Nav.Link href="https://leetcode.com/u/SSchonlau/" rel="noreferrer" target="_blank">LeetCode</Nav.Link>
             <Nav.Link href="https://www.linkedin.com/in/steven-schonlau/" rel="noreferrer" target="_blank">LinkedIn</Nav.Link>
           </Nav>
         </Navbar.Collapse>
       </Container>
     </Navbar>
   );
 }

export default NavBar;
